/**
 * How many fraction digits a currency DISPLAYS (2 for USD, 0 for JPY).
 * Capped at 2 because storage is uniform hundredths; Money.toDecimalString
 * clamps three-decimal currencies (KWD) and non-ISO commodity codes to the
 * same two digits, so rendered values round-trip through digit-based parsing.
 */
export const displayFractionDigits = (currency: string): number => {
  try {
    const digits = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).resolvedOptions().maximumFractionDigits;
    return Math.min(2, digits ?? 2);
  } catch {
    return 2;
  }
};

/**
 * The currency's smallest DISPLAYABLE amount, in stored hundredths: 1 for
 * USD cents, 100 for whole-yen JPY. Generated amounts (even splits,
 * suggestions) should be multiples of this so they render exactly and
 * survive re-editing in amount inputs.
 */
export const displayUnitHundredths = (currency: string): number =>
  10 ** (2 - displayFractionDigits(currency));
